import { withStaticProperties } from '@fhs/utils';

import { ListItemButton as ListItemButton_ } from './list-item-button';
import { ListItemButtonText } from './list-item-button-text';
export type { ListItemButtonProps } from './list-item-button';

export const ListItemButton = withStaticProperties(ListItemButton_, {
  Text: ListItemButtonText,
});
